module.exports = __webpack_public_path__ + "img/metal.fe034086.jpg";